import { useEffect, useState } from 'react';

const mobileMediaQuery = '(max-width: 768px)';

const getIsMobileViewport = () => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(mobileMediaQuery).matches;
};

export function useMobileViewport() {
  const [isMobileViewport, setIsMobileViewport] = useState(getIsMobileViewport);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(mobileMediaQuery);
    const handleChange = (event: MediaQueryListEvent) => setIsMobileViewport(event.matches);

    setIsMobileViewport(mediaQueryList.matches);
    mediaQueryList.addEventListener('change', handleChange);
    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, []);

  return isMobileViewport;
}
